import * as React from "react";
import { SvgIcon, SvgIconProps, makeStyles, Theme } from "@material-ui/core";

type Props = styleProps & SvgIconProps;

type styleProps = {
  primaryColor?: React.CSSProperties["color"];
  secondaryColor?: React.CSSProperties["color"];
};

const useStyles = makeStyles<Theme, styleProps>((theme: Theme) => ({
  root: ({ primaryColor, secondaryColor }) => ({
    "& .a": { fill: primaryColor || "#00ad6c" },
    "& .b": { fill: theme.palette.type == "dark" ? "#fff" : (secondaryColor || "#6e7878") },
  }),
}));

function APPLogo({ primaryColor, secondaryColor, ...props }: Props) {
  const c = useStyles({ primaryColor, secondaryColor });

  return (
    <SvgIcon className={c.root} {...props} viewBox="0 0 25.002 31.146">
      <g transform="translate(48.487 -714.322) rotate(90)">
        <path
          className="a"
          d="M1,10.893l2.831,2.831a18.02,18.02,0,0,1,25.483,0l2.831-2.831A22.036,22.036,0,0,0,1,10.893Zm5.663,5.663,2.831,2.831a10.014,10.014,0,0,1,14.157,0l2.831-2.831A14.03,14.03,0,0,0,6.663,16.555Z"
          transform="translate(713.322 19.038)"
        />
        <circle className="b" cx="4.5" cy="4.5" r="4.5" transform="translate(725.597 39.487)" />
      </g>
    </SvgIcon>
  );
}

export default APPLogo;
